import React from "react";

export const About = () => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <img src="img/manufacturing-illustration.png" className="img-responsive" alt="" />
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>About Us</h2>
              <p>
                GD Enterprise is a B2B trading company specializing in providing
                high-quality packaging materials such as paper and plastic. We
                are committed to empowering businesses by offering
                cost-effective and reliable solutions. Expanding our horizons,
                we are venturing into trading diverse goods to better serve our
                clients.
              </p>
              <h3>Why Choose Us?</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    <li>Trusted partner for B2B trading needs.</li>
                    <li>Extensive expertise in packaging materials.</li>
                    <li>Cost-effective and scalable solutions.</li>
                    <li>Dedicated to timely and reliable delivery.</li>
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    <li>Expanding into diverse goods trading.</li>
                    <li>Streamlined procurement process.</li>
                    <li>Commitment to quality and client satisfaction.</li>
                    <li>Adaptable solutions for evolving business needs.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
